import { defineStore } from "pinia";
import { useUserStore } from "./user";
import {
  fetchArticlesForCategory,
  fetchArticlesForType,
} from "../../api/article.js";
import { getBookmarkedArticles } from "../../api/bookmark";
import { useClientStore } from "./client";

export const useArticleStore = defineStore("article", {
  state: () => {
    return {
      articles: [],
      articlesForType: [],
    };
  },
  actions: {
    async getArticlesForCategory(categoryId) {
      let articlesForCategory = this.filterArticlesForCategory(categoryId);
      if (articlesForCategory.length <= 0) {
        try {
          const user = useUserStore();
          const client = useClientStore();
          const response = await fetchArticlesForCategory(
            client.code,
            categoryId,
            this.i18n.locale,
            user.externalUserId
          );

          if (response.data) {
            this.articles.push({
              categoryId: categoryId,
              articles: response.data,
            });
          }
        } catch (error) {
          return error;
        }

        return this.filterArticlesForCategory(categoryId);
      }

      return articlesForCategory;
    },
    filterArticlesForCategory(categoryId) {
      return this.articles.filter(
        (articleCollection) => articleCollection.categoryId === categoryId
      );
    },
    async getArticlesForType(articleType) {
      try {
        const user = useUserStore();
        const response = await fetchArticlesForType(
          user.clientCode,
          articleType,
          user.getLanguage
        );

        if (response.data) {
          this.articlesForType = response.data;
        }

        return this.articlesForType;
      } catch (error) {
        return error;
      }
    },
    async getBookmarkedArticles(externalUserId) {
      const res = await getBookmarkedArticles(externalUserId);

      let bookmarkedArticles = [];
      if (res) {
        bookmarkedArticles = res.data;
      }

      return bookmarkedArticles;
    },
  },
});
